module.exports = __webpack_public_path__ + "static/media/tela_login_md.100c002b.png";